import script from "./StatementPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./StatementPopup.vue?vue&type=script&setup=true&lang=js"

import "./StatementPopup.vue?vue&type=style&index=0&id=25913c1a&scoped=true&lang=css"

import exportComponent from "/Users/zsrb/Documents/中山日报/2025/zsrb-news-detail/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25913c1a"]])

export default __exports__